import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import TargetGroupCreate from '@app/views/ProjectTargetGroup/Create';
import { memo } from 'react';

export default memo(
  withIfUser(TargetGroupCreate)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
